import { useState, useEffect } from 'react'

/**
 * Returns a value that updates `ms` milliseconds after `value` stops changing.
 * Use for search fields: keep instant local input, debounce API/query side effects.
 *
 * @param {*} value - Source value (e.g. search input string)
 * @param {number} ms - Delay in milliseconds (e.g. 450 for order list search)
 */
export function useDebouncedValue(value, ms) {
  const [debounced, setDebounced] = useState(value)
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), ms)
    return () => clearTimeout(timer)
  }, [value, ms])
  return debounced
}
